/**
 * The move-details driver-assignment panel — the WHOLE panel (lite gate,
 * derivation verdict, assignability, rideshare link) lives in the shared
 * feature package; this shim injects only the dealer's routing. The embed's
 * sibling shim additionally injects its read-only mode and host branding —
 * that is the entire sanctioned difference between the portals here.
 */
import { Link } from 'react-router-dom';
import { Moves, Offers } from '@gql/base-types';
import { MoveDetailsOffer as SharedMoveDetailsOffer } from '@hopdrive/feature-driver-assignment';
import { ridesharePath } from '@features/products/productRoutes';

interface MoveDetailsOfferProps {
  move?: Moves;
  offers?: Offers[];
  isAssigningOrUnassigning?: boolean;
  /** Called when the user clicks the assign/unassign button. */
  onAssignOrUnassign?: () => void;
}

const MoveDetailsOffer = ({ move, offers, isAssigningOrUnassigning, onAssignOrUnassign }: MoveDetailsOfferProps) => (
  <SharedMoveDetailsOffer
    move={move}
    offers={offers}
    isAssigningOrUnassigning={isAssigningOrUnassigning}
    onAssignOrUnassign={onAssignOrUnassign}
    rideshareHref={rideMoveId => ridesharePath(rideMoveId)}
    rideshareLinkComponent={Link}
  />
);

export default MoveDetailsOffer;
